export const ROUTE_HOME = '/'
export const ROUTE_SERVICES = '/services'
export const ROUTE_SERVICES_INVENTIAEXPERIENCE_RESEARCH = `${ROUTE_SERVICES}/inventiaexperience-research`
export const ROUTE_SERVICES_INVENTIAEXPERIENCE_PRODUCTDESIGN = `${ROUTE_SERVICES}/inventiaexperience-productdesign`
export const ROUTE_SERVICES_INVENTIAEXPERIENCE_SERVICEDESIGN = `${ROUTE_SERVICES}/inventiaexperience-servicedesign`
export const ROUTE_SERVICES_INVENTIASOFTWARE_FULLSTACKDEVELOPMENT = `${ROUTE_SERVICES}/inventiasoftware-fullstackdevelopment`
export const ROUTE_SERVICES_INVENTIASOFTWARE_CLOUDENGINEERING = `${ROUTE_SERVICES}/inventiasoftware-cloudengineering`
export const ROUTE_SERVICES_INVENTIASOFTWARE_DEVOPSIMPLEMENTATION = `${ROUTE_SERVICES}/inventiasoftware-devopsimplementation`
export const ROUTE_SUCCESSSTORIES = '/success-stories'
export const ROUTE_SUCCESSSTORIES_BANKINGBBVA = `${ROUTE_SUCCESSSTORIES}/bbva`
export const ROUTE_SUCCESSSTORIES_BANKINGGRUPOGENTERA = `${ROUTE_SUCCESSSTORIES}/gentera`
export const ROUTE_SUCCESSSTORIES_BANKINGFINANCIERAPODEMOSPROGRESAR = `${ROUTE_SUCCESSSTORIES}/financierapodemosprogresar`
export const ROUTE_SUCCESSSTORIES_BANKINGION = `${ROUTE_SUCCESSSTORIES}/ion`
export const ROUTE_ABOUTUS = '/about-us'
export const ROUTE_CONTACTUS = '/contact-us'

export const ROUTE_LINKEDIN = 'https://www.linkedin.com/company/inventialab/'
export const ROUTE_INSTAGRAM = 'https://www.instagram.com/inventialab/?igshid=YmMyMTA2M2Y%3D'
export const ROUTE_FACEBOOK = 'https://www.facebook.com/profile.php?id=100077417485517'

export const TAG_INVENTIAEXPERIENCE = 'inventiaexperience'
export const TAG_INVENTIASOFTWARE = 'inventiasoftware'
export const TAG_METHODOLOGY = 'methodology'
export const TAG_JOIN_TEAM = 'join-team'
export const TAG_JOIN_TEAM_MOBILE = 'join-team-mobile'

export const EXTERNAL_ROUTE_ION = "https://www.ion.com.mx/"
export const EXTERNAL_ROUTE_GENTERA = "https://www.gentera.com.mx/gentera/"
export const EXTERNAL_ROUTE_PODEMOS_PROGRESAR = "https://podemos.mx/"
export const EXTERNAL_ROUTE_BBVA = "https://www.bbva.mx/"